import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { AllListLabelValue, ListItem } from '../models/liste.model';
import { Pack } from '../models/pack.model';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ListeService {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);

  getListNature(): Observable<ListItem[]> {
    return this.getList('ListeNatureIncident');
  }

  getListTheme(): Observable<ListItem[]> {
    return this.getList('ListeThemeIncident');
  }

  getListService(): Observable<ListItem[]> {
    return this.getList('ListeServiceContact');
  }

  getListFunction(): Observable<ListItem[]> {
    return this.getList('ListeFonctionContact');
  }

  getListGenre(): Observable<ListItem[]> {
    return this.getList('ListeGenreContact');
  }

  getListPays(): Observable<ListItem[]> {
    return this.getList('ListePays');
  }

  getListAnneeExerciceComptable(): Observable<ListItem[]> {
    return this.getList('ListeAnneeExerciceComptable');
  }

  getListPack(): Observable<Pack[]> {
    return this._http
      .get<Pack[]>(this.__URL_API__ + 'api/FichePartenaire/GetListePacks')
      .pipe(catchError(this.handleError));
  }

  private getList(typeListe: string): Observable<ListItem[]> {
    return this._http.get<ListItem[]>(this.__URL_API__ + 'api/Liste/' + typeListe).pipe(catchError(this.handleError));
  }

  getAllLists(): Observable<AllListLabelValue> {
    return this._http.get<AllListLabelValue>(this.__URL_API__ + 'api/liste').pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    return throwError(() => error.message || error);
  }
}
